import React from 'react';

export const HomeBannerPlaceholder = ({height}) =>{
    return(
        <div className='carousel_placeholder placeholder_color' style={{height:height}}></div>
    )
}